/* global Routes */
// @flow
import React from 'react'
import PRHeaderTop from '../../../components/pull_request/Header/PRHeaderTop'

type Props = {
  model: Object,
  currentAccount?: Object
}

export default class PRHeaderTopContainer extends React.Component<Props> {
  getPullRequestPath () {
    const projectSlug = this.props.model.projectSlug
    const accountSlug = this.props.currentAccount && this.props.currentAccount.get('slug')
    if (accountSlug) {
      return Routes.pull_requests_project_path(accountSlug, projectSlug)
    } else {
      return Routes.public_project_pull_request_path(projectSlug, '')
    }
  }

  render () {
    const model = this.props.model
    const props = {
      model,
      currentAccount: this.props.currentAccount,
      deltaIssues: model.get('issues_diff'),
      href: this.getPullRequestPath()
    }

    return (
      <PRHeaderTop {...props} />
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/pull_request/Header/PRHeaderTopContainer.js